import { fetchWorksConcil, fetchWorksConcils } from '../queries/worksConcils.queries'

import { skipToken, useQuery } from '@tanstack/react-query'

export const useWorksConcils = () =>
  useQuery({
    queryKey: ['works-concils'],
    queryFn: fetchWorksConcils,
  })

export const useWorksConcil = (id?: number) =>
  useQuery({
    queryKey: ['works-concils', id],
    queryFn: id ? () => fetchWorksConcil(id) : skipToken,
  })
